import { z } from "zod";
import { BaseResponseSchema } from "../../base/response/BaseResponseSchema";
import { PaymentSchema } from "./IndexPaymentResponse";

export const CreatePaymentResponseSchema = BaseResponseSchema(PaymentSchema);
export type CreatePaymentResponse = z.infer<typeof CreatePaymentResponseSchema>;